import { Chip, Stack } from '@mui/material';
import type { ZoneSummary } from '../../types/supplier.type';

interface LabelChipsProps {
  labels: ZoneSummary[] | undefined;
  size?: 'small' | 'medium';
  emptyFallback?: string;
}

export default function LabelChips({ labels, size = 'small', emptyFallback = '—' }: LabelChipsProps) {
  if (!labels || labels.length === 0) {
    return emptyFallback ? <>{emptyFallback}</> : null;
  }
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {labels.map((label) => (
        <Chip
          key={label.id}
          size={size}
          label={label.name}
          sx={{
            bgcolor: `${label.color}22`,
            color: label.color,
            fontWeight: 600,
            border: '1px solid',
            borderColor: `${label.color}55`,
          }}
        />
      ))}
    </Stack>
  );
}
